var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 530 530",
      "width": "200",
      "height": "200"
    }
  }, [_c('g', {
    attrs: {
      "id": "svg-1",
      "transform": "matrix(0.2512649893760681, 0, 0, 0.2512649893760681, -96.57250976562494, 4.910460948944092)"
    }
  }, [_c('g', {
    attrs: {
      "id": "svg-2"
    }
  }, [_c('g', {
    attrs: {
      "id": "SVGRepo_bgCarrier",
      "stroke-width": "0",
      "transform": "matrix(0.248047, 0, 0, 0.248047, 881.591553, 347.236969)"
    }
  }), _c('g', {
    attrs: {
      "id": "SVGRepo_tracerCarrier",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "transform": "matrix(0.248047, 0, 0, 0.248047, 881.591553, 347.236969)"
    }
  }), _c('g', {
    attrs: {
      "id": "SVGRepo_iconCarrier",
      "transform": "matrix(0.248047, 0, 0, 0.248047, 881.591553, 347.236969)"
    }
  }, [_c('g', {
    attrs: {
      "id": "svg-3",
      "transform": "matrix(3.979864, 0, 0, 3.979864, 1196.199463, 2118.139648)"
    }
  }, [_c('g', {
    attrs: {
      "id": "group-1",
      "stroke-width": "0",
      "transform": "matrix(0.999997, 0, 0, 0.999997, -803.484619, -901.903625)"
    }
  }), _c('g', {
    attrs: {
      "id": "group-2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "transform": "matrix(0.999997, 0, 0, 0.999997, -803.484619, -901.903625)"
    }
  }), _c('g', {
    attrs: {
      "id": "group-3",
      "transform": "matrix(0.999999, 0, 0, 0.999999, -803.484619, -901.903625)"
    }
  }, [_c('g', {
    attrs: {
      "id": "group-4",
      "stroke-width": "0",
      "transform": "matrix(3.985507, 0, 0, 3.985507, 1.874695, 0.230631)"
    }
  }), _c('g', {
    attrs: {
      "id": "group-5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "transform": "matrix(3.985507, 0, 0, 3.985507, 1.874695, 0.230631)"
    }
  }), _c('g', {
    attrs: {
      "id": "group-6",
      "transform": "matrix(3.985507, 0, 0, 3.985507, 1.874695, 0.230631)"
    }
  }, [_c('circle', {
    staticStyle: {
      "fill": "#f1543f"
    },
    attrs: {
      "cx": "256",
      "cy": "256",
      "r": "256"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#d83e20"
    },
    attrs: {
      "d": "M 508.497 298.324 L 373.226 163.052 L 269.935 267.062 L 107.961 366.133 L 255.564 511.995 C 255.711 511.995 255.855 512 256 512 C 382.966 512 488.324 419.566 508.497 298.324 Z"
    }
  }), _c('g', {
    attrs: {
      "id": "group-13",
      "stroke-width": "0",
      "transform": "matrix(0.249447, 0, 0, 0.249447, 1.68398, 411.749695)"
    }
  }), _c('g', {
    attrs: {
      "id": "group-14",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "transform": "matrix(0.249447, 0, 0, 0.249447, 1.68398, 411.749695)"
    }
  }), _c('g', {
    attrs: {
      "id": "Capa_1",
      "transform": "matrix(0.536841, 0, 0, 0.536841, -23.962765, 25.466988)"
    }
  }, [_c('g', {
    attrs: {
      "id": "group-10",
      "stroke-width": "0",
      "transform": "matrix(1, 0, 0, 1, 242.466217, 184.370483)"
    }
  }), _c('g', {
    attrs: {
      "id": "group-11",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "transform": "matrix(1, 0, 0, 1, 242.466217, 184.370483)"
    }
  }), _c('g', {
    attrs: {
      "id": "group-12",
      "transform": "matrix(1, 0, 0, 1, 242.466217, 184.370483)"
    }
  }, [_c('g', [_c('g', [_c('rect', {
    staticStyle: {
      "fill": "#ffe1b2"
    },
    attrs: {
      "x": "32",
      "y": "132",
      "width": "448",
      "height": "312"
    }
  })]), _c('g', [_c('rect', {
    staticStyle: {
      "fill": "#ffb980"
    },
    attrs: {
      "x": "32",
      "y": "396",
      "width": "448",
      "height": "48"
    }
  })]), _c('g', [_c('rect', {
    staticStyle: {
      "fill": "#ffb980"
    },
    attrs: {
      "x": "32",
      "y": "116",
      "width": "448",
      "height": "56"
    }
  })]), _c('g', [_c('path', {
    staticStyle: {
      "fill": "#7e5c62"
    },
    attrs: {
      "d": "M192,188H80c-4.418,0-8,3.582-8,8v240h128V196C200,191.582,196.418,188,192,188z"
    }
  })]), _c('g', [_c('g', [_c('path', {
    staticStyle: {
      "fill": "#5c546a"
    },
    attrs: {
      "d": "M504,452H8c-4.422,0-8-3.578-8-8s3.578-8,8-8h496c4.422,0,8,3.578,8,8S508.422,452,504,452z"
    }
  })])]), _c('g', [_c('g', [_c('path', {
    staticStyle: {
      "fill": "#5c546a"
    },
    attrs: {
      "d": "M176,340c-4.422,0-8-3.578-8-8v-16c0-4.422,3.578-8,8-8s8,3.578,8,8v16 C184,336.422,180.422,340,176,340z"
    }
  })])]), _c('g', [_c('path', {
    staticStyle: {
      "fill": "rgb(246, 119, 80)"
    },
    attrs: {
      "d": "M40,156L40,156c-13.255,0-24-10.745-24-24V76c0-8.837,7.163-16,16-16h32v72 C64,145.255,53.255,156,40,156z"
    }
  })]), _c('g', [_c('path', {
    staticStyle: {
      "fill": "#eee"
    },
    attrs: {
      "d": "M88,156L88,156c-13.255,0-24-10.745-24-24V60h48v72C112,145.255,101.255,156,88,156z"
    }
  })]), _c('g', [_c('path', {
    staticStyle: {
      "fill": "rgb(246, 119, 80)"
    },
    attrs: {
      "d": "M136,156L136,156c-13.255,0-24-10.745-24-24V60h48v72C160,145.255,149.255,156,136,156z"
    }
  })]), _c('g', [_c('path', {
    staticStyle: {
      "fill": "#eee"
    },
    attrs: {
      "d": "M184,156L184,156c-13.255,0-24-10.745-24-24V60h48v72C208,145.255,197.255,156,184,156z"
    }
  })]), _c('g', [_c('path', {
    staticStyle: {
      "fill": "rgb(246, 119, 80)"
    },
    attrs: {
      "d": "M232,156L232,156c-13.255,0-24-10.745-24-24V60h48v72C256,145.255,245.255,156,232,156z"
    }
  })]), _c('g', [_c('path', {
    staticStyle: {
      "fill": "#eee"
    },
    attrs: {
      "d": "M280,156L280,156c-13.255,0-24-10.745-24-24V60h48v72C304,145.255,293.255,156,280,156z"
    }
  })]), _c('g', [_c('path', {
    staticStyle: {
      "fill": "rgb(246, 119, 80)"
    },
    attrs: {
      "d": "M328,156L328,156c-13.255,0-24-10.745-24-24V60h48v72C352,145.255,341.255,156,328,156z"
    }
  })]), _c('g', [_c('path', {
    staticStyle: {
      "fill": "#eee"
    },
    attrs: {
      "d": "M376,156L376,156c-13.255,0-24-10.745-24-24V60h48v72C400,145.255,389.255,156,376,156z"
    }
  })]), _c('g', [_c('path', {
    staticStyle: {
      "fill": "rgb(246, 119, 80)"
    },
    attrs: {
      "d": "M424,156L424,156c-13.255,0-24-10.745-24-24V60h48v72C448,145.255,437.255,156,424,156z"
    }
  })]), _c('g', [_c('path', {
    staticStyle: {
      "fill": "#eee"
    },
    attrs: {
      "d": "M472,156L472,156c-13.255,0-24-10.745-24-24V60h32c8.837,0,16,7.163,16,16v56 C496,145.255,485.255,156,472,156z"
    }
  })]), _c('g', [_c('path', {
    staticStyle: {
      "fill": "#53dcff"
    },
    attrs: {
      "d": "M440,196H240c-4.418,0-8,3.582-8,8v160c0,4.418,3.582,8,8,8h200c4.418,0,8-3.582,8-8V204 C448,199.582,444.418,196,440,196z"
    }
  })]), _c('g', [_c('path', {
    staticStyle: {
      "fill": "#b3f4ff"
    },
    attrs: {
      "d": "M397.588,372H440c4.418,0,8-3.582,8-8v-9.47L289.47,196H232c-2.835,0-5.207,1.56-6.628,3.784 L397.588,372z"
    }
  })]), _c('g', [_c('polygon', {
    staticStyle: {
      "fill": "#ffffff"
    },
    attrs: {
      "points": "334.059,196 448,309.941 448,276 368,196 "
    }
  })]), _c('g', [_c('g', [_c('path', {
    staticStyle: {
      "fill": "#7e5c62"
    },
    attrs: {
      "d": "M440,380H240c-8.82,0-16-7.18-16-16V204c0-8.82,7.18-16,16-16h200c8.82,0,16,7.18,16,16v160 C456,372.82,448.82,380,440,380z M240,204v160h200.016L440,204H240z"
    }
  })])]), _c('g', [_c('path', {
    staticStyle: {
      "fill": "#53dcff"
    },
    attrs: {
      "d": "M176,292H96c-4.418,0-8-3.582-8-8v-72c0-4.418,3.582-8,8-8h80c4.418,0,8,3.582,8,8v72 C184,288.418,180.418,292,176,292z"
    }
  })]), _c('g', [_c('path', {
    staticStyle: {
      "fill": "#b3f4ff"
    },
    attrs: {
      "d": "M136.099,204H96c-4.418,0-8,3.582-8,8v11.784L156.216,292H176c4.418,0,8-3.582,8-8v-32.099 L136.099,204z"
    }
  })])])])])])])])])])])]);

}
var staticRenderFns = []

export { render, staticRenderFns }